module.exports = __webpack_public_path__ + "img/small-1.ae4ff13c.webp";